import { render } from "./PrenotaTavolo.vue?vue&type=template&id=15625df3&scoped=true"
import script from "./PrenotaTavolo.vue?vue&type=script&lang=js"
export * from "./PrenotaTavolo.vue?vue&type=script&lang=js"

import "./PrenotaTavolo.vue?vue&type=style&index=0&id=15625df3&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15625df3"]])

export default __exports__